/* eslint react/jsx-no-bind:0 */

import React, { Component, Fragment } from 'react';
import * as StringUtil from 'app/common/lib/StringUtil';
import FullPageModal from 'app/common/react/components/growth/unauth/FullPageModal/FullPageModal';
import FullPageModalCSS from 'app/common/react/components/growth/unauth/FullPageModal/FullPageModalCSS';
import FullPageSignup from 'app/common/react/components/growth/unauth/signup/FullPageSignup/FullPageSignup';
import i18n from 'app/common/lib/i18n';
import InlineStyle from 'app/common/react/components/InlineStyle';
import PageController from 'app/common/react/components/growth/unauth/PageController';
import PinCSS from 'app/common/react/components/growth/unauth/pin/PinCSS';
import PinDescriptionCSS from 'app/common/react/components/growth/unauth/pin/PinDescription/PinDescriptionCSS';
import PinGrid from 'app/common/react/components/growth/unauth/PinGrid/PinGrid';
import PinGridCSS from 'app/common/react/components/growth/unauth/PinGrid/PinGridCSS';
import PinShapeProps from 'app/common/react/components/common/PinRep/PinShapeProps';
import PropTypes from 'prop-types';
import resourceFactory from 'app/common/lib/ResourceFactory';
import SignupCSS from 'app/common/react/components/growth/unauth/signup/SignupCSS';
import UnauthBoardsList from 'app/common/react/components/growth/unauth/UnauthUserProfilePage/UnauthBoardsList';
import withResource from 'app/common/lib/react/withResource';
import { compose } from 'redux';
import { GRID_ITEM_WIDTH } from 'app/common/lib/react/gridUtils';
import { SignupSource } from 'app/common/react/components/growth/unauth/signup/constants';
import withUnauthSeoExperiments, {
  ExperimentsPropType,
} from 'app/common/lib/react/withUnauthSeoExperiments';
import { Box, Heading, Spinner } from 'gestalt';

const styles = {
  emptyBoardSection: {
    margin: 'auto',
    maxWidth: '800px',
    padding: '18px 0',
  },
  emptyBoardText: {
    color: '#8e8e8e',
    fontSize: '20px',
    fontWeight: 'bold',
    WebkitFontSmoothing: 'antialiased',
  },
  noScroll: {
    position: 'fixed',
  },
};

const cssStyles = (pinImageWidthMin, pinImageWidthMax, seoUnauthExperiments, context) =>
  FullPageModalCSS() +
  PinCSS(context.pageType, seoUnauthExperiments) +
  PinGridCSS() +
  SignupCSS() +
  PinDescriptionCSS(seoUnauthExperiments, context.pageType);

export class UnauthUserProfileContent extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      modalType: 'signup',
      showSignupModal: false,
    };
  }

  getPinsPageSize() {
    if (this.context.isBot) {
      return 125;
    } else {
      return 25;
    }
  }

  showSignupModal(type, signupSource, e) {
    this.setState({ showSignupModal: true, modalType: type, signupSource });
    e.preventDefault();
  }

  loadPins(username, pageSize, pins, bookmarks, callback) {
    const profilePinsResource = resourceFactory.create('UnauthProfilePinFeedResource', {
      add_vase: true,
      bookmarks,
      field_set_key: 'unauth_react',
      page_size: pageSize,
      pins_only: true,
      username,
    });

    profilePinsResource.callGet().then((response) => {
      callback(response.resource_response.data, response.bookmarks);
    });
  }

  formatBoardHeaderText() {
    if (!this.props.user.data) {
      return null;
    }
    const { full_name, username } = this.props.user.data.profile;
    return StringUtil.safeFormat(
      i18n._("{{user}}'s best boards", "Label for user's best board section on profile"),
      {
        user: full_name || username,
      },
    );
  }

  renderPinGrid(pinImageWidthMin, pinImageWidthMax) {
    const pins = this.props.pinsNode.data;
    const { full_name, username } = this.props.user.data.profile;
    const pageSize = this.getPinsPageSize();
    if (pins && pins.length > 0) {
      const showSignupModal = () => {
        this.showSignupModal(this, 'signup', SignupSource.userProfilePage);
      };
      return (
        <React.Fragment>
          <div className="gridCentered">
            <Box display="flex" justifyContent="center">
              <Box marginBottom={11} maxWidth="800px" width="100%">
                <Heading accessibilityLevel={2} size="xs" dan>
                  {/* eslint-disable react/no-danger*/}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: StringUtil.safeFormat(i18n._('More ideas from {{user}}'), {
                        user: full_name || username,
                      }),
                    }}
                  />
                  {/* eslint-enable react/no-danger*/}
                </Heading>
              </Box>
            </Box>
          </div>
          <PinGrid
            bookmarks={[]}
            items={pins}
            loadPins={this.loadPins.bind(this, username, pageSize)}
            pinImageWidthMax={pinImageWidthMax}
            pinImageWidthMin={pinImageWidthMin}
            showSignupModal={showSignupModal}
          />
        </React.Fragment>
      );
    } else {
      return null;
    }
  }

  renderBoardGrid() {
    if (!this.props.user.data) {
      return null;
    }
    const { isLoaded } = this.props.user;
    const boards = this.props.boardsNode.data;
    const { full_name } = this.props.user.data.profile;
    if (boards && boards.length > 0) {
      const showSignupModal = () => {
        this.showSignupModal(this, 'signup', SignupSource.userProfilePage);
      };
      return (
        <Fragment>
          <Box display="flex" justifyContent="center" marginBottom={4} marginTop={2}>
            <Box maxWidth="800px" width="100%">
              <Heading accessibilityLevel={2} size="xs">
                {/* eslint-disable react/no-danger*/}
                <div dangerouslySetInnerHTML={{ __html: this.formatBoardHeaderText() }} />
                {/* eslint-enable react/no-danger*/}
              </Heading>
            </Box>
          </Box>
          <UnauthBoardsList
            boards={boards}
            isRetina={this.context.userAgent.isRetina}
            resourceLoaded={isLoaded}
            showSignupModal={showSignupModal}
            seoUnauthExperiments={this.props.seoUnauthExperiments}
          />
        </Fragment>
      );
    } else {
      return (
        <div style={styles.emptyBoardSection}>
          <div style={styles.emptyBoardText}>
            {/* eslint-disable react/no-danger*/}
            <div
              dangerouslySetInnerHTML={{
                __html: StringUtil.safeFormat(i18n._("{{user}} hasn't created any boards yet"), {
                  user: full_name,
                }),
              }}
            />
            {/* eslint-enable react/no-danger*/}
          </div>
        </div>
      );
    }
  }

  renderFullPageSignup = () => (
    <FullPageSignup
      container="UnauthProfilePage"
      signupSource={this.state.signupSource}
      type={this.state.modalType}
    />
  );

  render() {
    if (
      !this.props.user ||
      !this.props.user.isLoaded ||
      (this.props.boardsNode && !this.props.boardsNode.isLoaded)
    ) {
      return (
        <Spinner
          show
          accessibilityLabel={i18n._(
            'Profile boards are loading',
            'Label shown for loading spinner for content',
          )}
        />
      );
    }
    const pinImageWidth = GRID_ITEM_WIDTH;
    const pinImageWidthMax = pinImageWidth;
    const pinImageWidthMin = pinImageWidth;

    const cssStylesString = cssStyles(
      pinImageWidthMin,
      pinImageWidthMax,
      this.props.seoUnauthExperiments,
      this.context,
    );

    return (
      <PageController page="profile">
        <Box display="flex" alignSelf="center" marginTop={9}>
          <div style={{ margin: 'auto' }}>
            <div style={this.state.showSignupModal ? styles.noScroll : null}>
              <InlineStyle unsafeCSS={cssStylesString} />
              {this.renderBoardGrid()}
              {this.renderPinGrid(pinImageWidthMin, pinImageWidthMax)}
              {this.state.showSignupModal ? (
                <FullPageModal renderContent={this.renderFullPageSignup} />
              ) : null}
            </div>
          </div>
        </Box>
      </PageController>
    );
  }
}

const BoardProps = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    owner: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
);

UnauthUserProfileContent.propTypes = {
  user: PropTypes.shape({
    data: PropTypes.shape({
      profile: PropTypes.shape({
        interests: PropTypes.array,
        full_name: PropTypes.string.isRequired,
        username: PropTypes.string.isRequired,
      }),
    }),
    isLoaded: PropTypes.bool.isRequired,
  }).isRequired,
  boardsNode: PropTypes.shape({
    data: BoardProps,
    isLoaded: PropTypes.bool.isRequired,
  }),
  pinsNode: PropTypes.shape({
    data: PropTypes.arrayOf(PinShapeProps),
    isLoaded: PropTypes.bool.isRequired,
  }),
};

UnauthUserProfileContent.contextTypes = {
  isBot: PropTypes.bool,
  userAgent: PropTypes.shape({
    isRetina: PropTypes.bool.isRequired,
  }).isRequired,
  pageType: PropTypes.string.isRequired,
  seoUnauthExperiments: ExperimentsPropType,
};

export default compose(
  // $FlowFixMe: new errors found from flow 0.96 upgrade
  withResource({
    name: 'UserProfileBoardResource',
    key: 'boardsNode',
    options: ({ params }) => ({
      field_set_key: 'profile_unauth_react_grid_item',
      username: params.username,
      force_node: true,
    }),
  }),
  withResource({
    name: 'UserProfilePinResource',
    key: 'pinsNode',
    options: ({ params }) => ({
      username: params.username,
      force_node: true,
    }),
  }),
  withUnauthSeoExperiments,
)(UnauthUserProfileContent);
